import { ZipcodeErrorCode } from './zipcode-error-code';

export class ZipcodeError extends Error {
  constructor(private code: ZipcodeErrorCode) {
    super(ZipcodeErrorCode[code]);
    Object.setPrototypeOf(this, ZipcodeError.prototype);
  }

  /**
   * Returns the Error code
   */
  getCode(): ZipcodeErrorCode {
    return this.code;
  }
}
